<template>
  <div>
    <client-detail
      v-if="fieldList.length"
      :id="order['client']['id']"
      :fieldList="fieldList"
      @input="save"
      :changeItem="false"
    />
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../../plugins/functions";
import ClientDetail from "@/components/Partners/ClientDetail";
export default {
  components: {
    ClientDetail,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  created() {
    this.$http
      .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
      .then((response) => {
        this.fieldList = [
          {
            col: " col-12",
            key: "first_name",
            label: "Имя",
            type: "field",
            textType: "text",
          },
          {
            col: " col-12",
            key: "last_name",
            label: "Фамилия",
            type: "field",
            textType: "text",
          },
          {
            col: " col-12",
            key: "family_name",
            label: "Отчество",
            type: "field",
            textType: "text",
          },

          {
            col: " col-12",
            key: "birthday",
            label: "Дата рождения",
            type: "field",
            textType: "date",
          },
          {
            col: " col-12",
            key: "passport_issued",
            label: "Кем выдан",
            type: "alif-passport-issue",
            textType: "text",
            partner: response.data.data,
          },
          {
            col: " col-12 col-md-12",
            key: "gender",
            labelKey: "gender",
            label: "Пол",
            type: "static_radio",
            items: [
              { id: "male", title: "Мужской" },
              { id: "fmale", title: "Женский" },
            ],
          },
          {
            col: " col-12",
            key: "passport_address",
            label: "Адрес по прописке",
            type: "field",
            textType: "text",
          },
          {
            col: " col-12",
            key: "passport_region",
            label: "Область проживания",
            type: "alif-region",
            partner: response.data.data,
          },
          {
            col: " col-12",
            key: "passport_city",
            label: "Город проживания",
            type: "field",
            textType: "text",
          },
          {
            col: " col-12",
            key: "passport_nationality",
            label: "Национальность",
            type: "field",
            textType: "text",
          },

          {
            col: " col-12",
            key: "passport_issued_at",
            label: "Дата выдачи",
            type: "field",
            textType: "date",
          },

          {
            col: " col-12",
            key: "passport_exp",
            label: "Срок паспорта",
            type: "field",
            textType: "date",
          },
          {
            col: " col-12",
            key: "PINFL",
            label: "ПИНФЛ",
            type: "field",
            textType: "number",
          },
        ];
      });
  },
  data() {
    return {
      fieldList: [],
      dataLocal: {
        city_name: "",
        nationality_name: "",
        passportRegion: "",
        region: "",
      },
    };
  },
  methods: {
    async save(data) {
      const sendData = {
        address: data["passport_address"],
        birth_date: data["birthday"],
        expiry_date: data["passport_exp"],
        issue_date: data["passport_issued_at"],
        passport_issuer_name: data["passport_issued"],
        name: data["first_name"],
        surname: data["last_name"],
        patronymic: data["family_name"],
        pinfl: data["PINFL"],
        passport_id: data["passport_number"],
        gender: data["gender"] === "male" ? "M" : "F",
        type: data["passport_prefix"] == "ID" ? "ID" : "Passport",
        city_name: data["passport_city"],
        nationality_name: data["passport_nationality"],
        passportRegion: data["passport_region"],
        region: data["passport_region"].toLowerCase(),
      };

      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http({
        url: `${partner["endpoint_url"]}clients/clients/${this.value.id}/passport`,
        method: "POST",
        data: sendData,
        headers: {
          Authorization: `Bearer ${partner["api_secret_key"]}`,
        },
      })
        .then((response) => {
          this.$emit("update", true);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>